import { render, staticRenderFns } from "./history-sale.vue?vue&type=template&id=5cf59c8c&scoped=true&"
import script from "./history-sale.vue?vue&type=script&lang=js&"
export * from "./history-sale.vue?vue&type=script&lang=js&"
import style0 from "./history-sale.vue?vue&type=style&index=0&id=5cf59c8c&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cf59c8c",
  null
  
)

export default component.exports